
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.758 9.79v-.188c-.662-.787-1.154-1.586-1.477-2.399a6.65 6.65 0 01-.476-2.437c0-.886.174-1.675.523-2.368a3.853 3.853 0 011.5-1.617c.646-.38 1.38-.57 2.203-.57.854 0 1.581.167 2.18.5.604.328 1.062.82 1.375 1.476.312.657.469 1.438.469 2.344 0 .526-.06 1.034-.18 1.524a7.978 7.978 0 01-.46 1.383 9.258 9.258 0 01-1.39 2.203v.148h.71c.255 0 .46-.013.617-.039a.831.831 0 00.382-.148.682.682 0 00.227-.305c.052-.13.101-.3.148-.508h.766L9.641 11H6.023V9.875c.49-.844.855-1.695 1.094-2.555a9.455 9.455 0 00.367-2.586c0-.885-.109-1.614-.328-2.187-.213-.573-.515-.99-.906-1.25-.385-.266-.846-.399-1.383-.399-.526 0-.976.149-1.351.446-.37.297-.654.732-.852 1.304-.193.573-.289 1.256-.289 2.047 0 .938.122 1.828.367 2.672.245.844.607 1.68 1.086 2.508V11H.227l-.235-2.203h.766c.057.26.11.448.156.562a.69.69 0 00.18.258.794.794 0 00.312.133c.14.026.365.04.672.04h.68z","fill":"currentColor"}})])
          )
        }
      }
    